import React, {Component} from 'react';
import { Nav, TabPane, NavItem, Row, NavLink, TabContent, Col, Card, CardHeader, FormText, CardBody, Button, CardFooter, Modal, ModalHeader, ModalFooter, ModalBody, Input, FormGroup, Label , Badge } from 'reactstrap';
import classnames from 'classnames';
import Widget04 from '../../Widgets/Widget04';
import $ from 'jquery';
import { Redirect } from 'react-router-dom';
import {DataTable} from 'primereact/components/datatable/DataTable';
import {Column} from 'primereact/components/column/Column';
import {ColumnGroup} from 'primereact/components/columngroup/ColumnGroup';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/omega/theme.css';
import 'font-awesome/css/font-awesome.css';
import { connect } from 'react-redux';
import ReactHLS from 'react-hls';


class LiveStoryboardDetailsPage extends Component {


  constructor(props) {
    super(props);
    this.state = {
      navigate: false,
      path:"",
      uploadModalOpen:false,
      editShotModalOpen:false,
      scriptDetail:Object,
      detailsShotModalOpen:false,
      contentStatus:false,
      activeTab:'1',
      activeAssetTab:'11',
      activeShotTab:'111',
      storyboardDetails:Object,
      selectedShot:Object,
      assetType:'',
      shotMedia:'',
      shotType:'',
      isVideo:true,
      activeAssetUrl:'',
      rawAssets: [
                {Date: '09/02/2017', Project: 'Visit CBR', Storyboard: 'Dev-visitCBR-123456',AssetType:'Video',ShotType:'UGV', shot: '13', User: 'John Citizen',ShotMedia:'Movie',Favourite:"Yes"},
                {Date: '10/02/2017', Project: 'Visit CBR', Storyboard: 'Dev-visitCBR-123456',AssetType:'Image',ShotType:'DG', shot: '13', User: 'Chris Brown',ShotMedia:'Shot',Favourite:"Yes"},

            ],
      assets:[]
    }

    this.uploadModalOpen = this.uploadModalOpen.bind(this);
    this.uploadModalClose = this.uploadModalClose.bind(this);
    this.detailsShotOpen = this.detailsShotOpen.bind(this);
    this.detailsShotClose = this.detailsShotClose.bind(this);
    this.toggle = this.toggle.bind(this);
    this.suspend = this.suspend.bind(this);
    this.release = this.release.bind(this);
    this.assetToggle = this.assetToggle.bind(this);
    this.shotToggle = this.shotToggle.bind(this);
    this.renderDetailsBody = this.renderDetailsBody.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.getSearchableAssets = this.getSearchableAssets.bind(this);
    this.renderTag = this.renderTag.bind(this);
    this.ReleaseToDev = this.ReleaseToDev.bind(this);
  }

  renderTag() {
    if (this.state.selectedSale && this.state.selectedSale.url) {
      if (this.state.selectedSale.isVideo) {
        if(this.state.selectedSale.isHLS) {
          return (
            <ReactHLS style={{"width":"auto", "height":"300"}} videoProps={{"width":"auto", "height":"300"}} url={this.state.selectedSale.url}/>
            )
        } else {
          return (
              <video style={{"width":"auto", "height":"300"}} width="auto" height="300" controls src={this.state.selectedSale.url}></video>
            )
        }
      } else {
        return (
           <img style={{"width":"100%", "height":"100%"}} src={this.state.selectedSale.url} />
        )
      }
    }
  }

   resetFilters() {
    this.setState({
       assetType:'',
       shotMedia:'',
       shotType:'',
       isFavourite:false,
    })

  }


  getSearchableAssets() {
    let searchParameter ="";
    let skip = false;


    if(this.state.shotType === "DG" && this.state.shotMedia === "Shot" && this.state.assetType === "Video")
    {
      searchParameter = "?assetType=ShotExplanation&mediaType=Video";
    }
    else if(this.state.shotType === "DG" && this.state.shotMedia === "Shot" && this.state.assetType === "Image") {
      skip = true;

    }
    else if(this.state.shotType === "DG" && this.state.shotMedia === "Shot" && this.state.assetType === "Audio") {
      skip = true;

    }

    else if(this.state.shotType === "DG" && this.state.shotMedia === "Shot") {
      searchParameter = "?assetType=ShotExplanation";
    }

    else if(this.state.shotType === "DG" && this.state.shotMedia === "Movie" && this.state.assetType === "Video") {
      searchParameter = "?assetType=ScriptExplanation&mediaType=Video";
    }

    else if(this.state.shotType === "DG" && this.state.shotMedia === "Movie" && this.state.assetType === "Image") {
      skip = true;
    }

    else if(this.state.shotType === "DG" && this.state.shotMedia === "Movie" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "DG" && this.state.shotMedia === "Movie") {
      searchParameter = "?assetType=ScriptExplanation";
    }

    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Shot" && this.state.assetType === "Video") {
      searchParameter = "?assetType=FlicShot&mediaType=Video";
    }

    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Shot" && this.state.assetType === "Image") {
      skip = true;
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Shot" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Shot") {
      searchParameter = "?assetType=FlicShot";
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Movie" && this.state.assetType === "Video") {
      searchParameter = "?assetType=Flic&mediaType=Video";
    }

    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Movie" && this.state.assetType === "Image") {
      searchParameter = "?assetType=FlicThumbnail&assetType=FlicLandscapeStill&mediaType=Image";
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Movie" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "UGV" && this.state.shotMedia === "Movie") {
      searchParameter = "?assetType=Flic";
    }
    else if(this.state.shotType === "DG" && this.state.assetType === "Image") {
      skip = true;
    }
    else if(this.state.shotType === "DG" && this.state.assetType === "Video") {
      searchParameter = "?assetType=ShotExplanation&assetType=ScriptExplanation&mediaType=Video";
    }
    else if(this.state.shotType === "DG" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "UGV" && this.state.assetType === "Image") {
      searchParameter = "?assetType=FlicThumbnail&assetType=FlicLandscapeStill&mediaType=Image";
    }
    else if(this.state.shotType === "UGV" && this.state.assetType === "Video") {
      searchParameter = "?assetType=Flic&assetType=FlicShot&mediaType=Video";
    }
    else if(this.state.shotType === "UGV" && this.state.assetType === "Audio") {
      skip = true;
    }
    else if(this.state.shotType === "DG") {
      searchParameter = "?assetType=ScriptExplanation&assetType=ShotExplanation";
    }
    else if(this.state.shotType === "UGV") {
      searchParameter = "?assetType=Flic&assetType=FlicShot";
    }
    else if(this.state.shotType === "Stock" && this.state.shotMedia === "Shot" && this.state.assetType==="Image") {
      searchParameter = "?assetType=ShotThumbnail&assetType=ShotImage&mediaType=Image";
    }
    else if(this.state.shotType === "Stock" && this.state.shotMedia === "Shot" && this.state.assetType==="Video") {
      //Todo: This should be StockFlic

       searchParameter = "?assetType=OtherAsset";
    }
    else if(this.state.shotType === "Stock" && this.state.shotMedia === "Shot" && this.state.assetType==="Audio") {
       skip = true;
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Shot" ) {
      searchParameter = "?assetType=OtherAsset&assetType=ShotThumbnail&assetType=ShotImage&assetType=StockFlic";
    }
    else if( this.state.shotType === "Stock" && this.state.assetType === "Video" ) {
      searchParameter = "?assetType=OtherAsset";
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Movie" && this.state.assetType==="Image" ) {
      searchParameter = "?assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage&mediaType=Image";
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Movie" && this.state.assetType==="Video" ) {
      skip = true;
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Movie" && this.state.assetType==="Audio" ) {
      skip = true;
    }
    else if( this.state.shotType === "Stock" && this.state.shotMedia === "Movie" ) {
      searchParameter = "?assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage";
    }
    else if(this.state.shotType === "Stock") {
      searchParameter = "?assetType=ShotThumbnail&assetType=ShotImage&assetType=OtherAsset&assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage";
    }
    else if( this.state.shotMedia === "Movie" && this.state.assetType==="Video" ) {
      searchParameter = "?assetType=ScriptExplanation&assetType=Flic&mediaType=Video";
    }
    else if( this.state.shotMedia === "Movie" && this.state.assetType==="Image" ) {
      searchParameter = "?assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage&assetType=FlicThumbnail&assetType=FlicLandscapeStill&mediaType=Image";
    }
    else if( this.state.shotMedia === "Movie" && this.state.assetType==="Audio" ) {
      skip = true;
    }
    else if( this.state.shotMedia === "Movie" ) {
      searchParameter = "?assetType=ScriptExplanation&assetType=Flic&assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage&assetType=FlicThumbnail&assetType=FlicLandscapeStill";
    }
    else if(this.state.shotMedia==="Shot" && this.state.assetType==="Video" ) {
      searchParameter = "?assetType=ShotExplanation&assetType=FlicShot&assetType=StockFlic&mediaType=Video";

    }
    else if(this.state.shotMedia==="Shot" && this.state.assetType==="Image" ) {
      searchParameter = "?assetType=ShotImage&assetType=ShotThumbnail&mediaType=Image";

    }
    else if(this.state.shotMedia==="Shot" && this.state.assetType==="Audio" ) {
      skip = true;

    }
    else if(this.state.shotMedia==="Shot") {
      searchParameter = "?assetType=ShotExplanation&assetType=OtherAsset&assetType=FlicShot&assetType=StockFlic&assetType=ShotImage&assetType=ShotThumbnail";
    }
    else if(this.state.assetType==="Image") {
      searchParameter = "?assetType=ShotImage&assetType=ShotThumbnail&assetType=ScriptThumbnail&assetType=ScriptPortraitImage&assetType=ScriptLandscapeImage&assetType=FlicThumbnail&assetType=FlicLandscapeStill&mediaType=Image";
    }
    else if(this.state.assetType==="Video") {
      searchParameter = "?assetType=ShotExplanation&assetType=OtherAsset&assetType=ScriptExplanation&assetType=FlicShot&assetType=Flic";

    }
    else if(this.state.assetType==="Audio") {
      skip = true;
    }
    else if(this.state.assetType === '' && this.state.shotMedia === '' && this.state.shotType === '') {
      searchParameter = "";
    }

    if(searchParameter ==="") {
      searchParameter+="?pageSize=2000";
    } else {
      searchParameter+="&pageSize=2000";
    }
    let pId = "&scriptId=" + this.state.scriptDetail.id;
    searchParameter+=pId;

    if(!skip) {

      let authToken = this.props.user.authToken;
      let cId = this.props.user.customerId;

      $.ajax({
          type: 'GET',
          url: `https://screen.mobflic.com/v1/customers/${cId}/assets${searchParameter}`,
          beforeSend: function (xhr) {
              xhr.setRequestHeader("X-Auth-Token",authToken);
          },
          success: (res) => {
              this.setState({
                rawAssets:res.result.hits,
                assets:[]
              },() => {
                let processedAssetItem;
                let newAssets = [];
                for(var key in this.state.rawAssets) {
                  if (this.state.rawAssets[key].assetId!="") {

                    let date = "";
                    date = this.state.rawAssets[key].assetId.substring(0,12).split('/');
                    if(date.length > 2)
                    {
                      date = date[0] + "/" + date[1] + "/" + date[2];
                    }

                    processedAssetItem = {
                      date:date,
                      projectType:this.state.rawAssets[key].projectTitle,
                      scriptTitle:this.state.rawAssets[key].scriptTitle,
                      shotNumber:this.state.rawAssets[key].shotNumber,
                      shotTitle:this.state.rawAssets[key].name,
                      user:this.state.rawAssets[key].userEmail,
                      mediaType:this.state.rawAssets[key].mediaType?this.state.rawAssets[key].mediaType:"Other",
                      assetType:this.state.rawAssets[key].assetType,
                      assetId:this.state.rawAssets[key].assetId,
                      projectId:this.state.rawAssets[key].projectId,
                      scriptId:this.state.rawAssets[key].scriptId,
                      flicId:this.state.rawAssets[key].flicId,
                      flicShotId:this.state.rawAssets[key].flicShotId
                    }

                    processedAssetItem.isVideo = processedAssetItem.mediaType == "Image"?false:true;

                    if (processedAssetItem.assetId) {
                      processedAssetItem.isHLS = processedAssetItem.assetId.substr(processedAssetItem.assetId.length-1,1)=="8";

                      if (processedAssetItem.assetType=="Flic" || processedAssetItem.assetType=="FlicShot" || processedAssetItem.assetType=="FlicLandscapeStill" || processedAssetItem.assetType=="FlicThumbnail") {
                        processedAssetItem.url = "https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(processedAssetItem.assetId) + "?storyboardId=" + processedAssetItem.scriptId + "&flicId=" + processedAssetItem.flicId + "&authToken=" + this.props.user.authToken;
                      }
                      else {
                        processedAssetItem.url = "https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(processedAssetItem.assetId) + "?storyboardId=" + processedAssetItem.scriptId + "&authToken=" + this.props.user.authToken;
                      }
                    }

                    switch(this.state.rawAssets[key].assetType)
                    {
                    case "ShotExplanation":
                        processedAssetItem.sourceType="DG";
                        processedAssetItem.shotMedia="Shot";

                      break;
                    case "ScriptExplanation":
                        processedAssetItem.sourceType="DG";
                        processedAssetItem.shotMedia="Movie";
                      break;
                    case "FlicShot":
                         processedAssetItem.sourceType="UGV";
                         processedAssetItem.shotMedia="Shot";
                      break;
                    case "Flic":
                         processedAssetItem.sourceType="UGV";
                         processedAssetItem.shotMedia="Movie";
                      break;
                    case "ShotImage":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Shot";
                      break;

                    case "ShotThumbnail":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Shot";
                      break;

                    case "ScriptThumbnail":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Movie";
                      break;

                    case "ScriptPortraitImage":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Movie";
                      break;

                    case "ScriptLandscapeImage":
                          processedAssetItem.sourceType="Stock";
                          processedAssetItem.shotMedia="Movie";
                      break;

                    case "FlicThumbnail":
                         processedAssetItem.sourceType="UGV";
                         processedAssetItem.shotMedia="Movie";
                      break;

                    case "FlicLandscapeStill":
                        processedAssetItem.sourceType="UGV";
                        processedAssetItem.shotMedia="Image";
                      break;

                    case "OtherAsset":
                        processedAssetItem.sourceType="Stock";
                        processedAssetItem.shotMedia="Shot";
                      break;
                    //Todo: Stock Flic

                      default:
                          processedAssetItem.sourceType="Other";
                          processedAssetItem.shotMedia="Other";
                  }
                  newAssets.push(processedAssetItem);

                  }
                }
                this.setState({
                  assets:newAssets
                })
              })
          },
          error: (res,a,b) => {
              console.log(res);
              console.log(a);
              console.log(b);
          }
      });
    } else {
      this.setState({assets:[]})
    }

  }

  componentWillMount() {

      let cId = this.props.user.customerId;
      let authToken = this.props.user.authToken;
      let id = parseInt(this.props.match.params.Id);
      $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${id}`,
          type: 'GET',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {
            this.setState({ scriptDetail :res.result, contentStatus:true}, () => {this.getSearchableAssets()} )
          },

          error: (res,a,b) => {
              console.log(res);
          }


      });

    }


  detailsShotOpen(shot) {
    this.setState({
      detailsShotModalOpen:true,
      selectedShot:shot
    })
  }


  detailsShotClose() {
    this.setState({
      detailsShotModalOpen:false
    })
  }

  assetToggle(tab) {
    if (this.state.activeAssetTab !== tab) {
      this.setState({
        activeAssetTab: tab
      });
    }

  }

  shotToggle(tab) {
     if (this.state.activeShotTab!== tab) {
      this.setState({
        activeShotTab: tab
      });
    }

  }


  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  redirectModifyPage() {
    this.setState({
      navigate:true,
      path:"YourStoryboards/Edit/1"
    })
  }

  editShotModalOpen() {
    this.setState({
      editShotModalOpen:true
    })
  }

  suspend() {
     let cId = this.props.user.customerId;
      let authToken = this.props.user.authToken;
      let id = parseInt(this.props.match.params.Id);
      $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${id}/suspend`,
          type: 'POST',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {
            console.log(res);
            this.setState({navigate:true, path:"YourStoryboards"});

          },

          error: (res,a,b) => {
              console.log(res);
          }


      });
  }

  release() {
    let sId = this.state.scriptDetail.id;
    let cId = this.props.user.customerId;
    let authToken = this.props.user.authToken;

    let data = {
      hires:true
     };
     let jsonData = JSON.stringify(data);

     $.ajax({
          url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/release`,
          type: 'POST',
          data: jsonData,
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {
            this.setState({
              path:"YourStoryboards",
              navigate:true
            })
         },
        error: (res,a,b) => {
            console.log(res);
            this.setState({releaseFailureOpen:true})
            this.setState({msg: res.messages})
        }
      });
  }

  editShotModalClose() {
    this.setState({
      editShotModalOpen:false
    })
  }

  uploadModalOpen() {
    this.setState({
      uploadModalOpen: true
    });
  }

  uploadModalClose() {
    this.setState({
      uploadModalOpen: false
    });
  }


  ReleaseToDev() {


        let cId = this.props.user.customerId;
        let sId = parseInt(this.props.match.params.Id);
        let authToken = this.props.user.authToken;

       $.ajax({
          url: `https://screen.mobflic.com/v1/current-user/projects`,
          type: 'GET',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res,a,b) => {

            for (var i=0;i<res.result.projects.length;i++)
            {
                if (res.result.projects[i].projectType == "Dev") {

                  let data = {projectId:res.result.projects[i].id}
                  let jsonData = JSON.stringify(data);
                  $.ajax({
                      url: `https://screen.mobflic.com/v1/customers/${cId}/storyboards/${sId}/project`,
                      type: 'POST',
                      contentType:"application/json",
                      data:jsonData,
                      beforeSend: function (xhr) {
                              xhr.setRequestHeader ("X-Auth-Token",authToken);
                      },
                      success: (res) => {
                       this.setState({
                        navigate:true,
                        path:"YourStoryboards"
                       })
                      },
                      error: (res,a,b) => {
                          console.log(res);
                      }


                  });
                };
            }
           console.log(res);
         },
        error: (res,a,b) => {
            console.log(res);
        }

      });





  }


  renderDetailsBody() {
    if(this.state.contentStatus) {

      const showSuspendButton = this.state.scriptDetail.status === "Published";
      const showReleaseButton = this.state.scriptDetail.status === "Draft";

      return (
        <div>


      <Row style={{marginTop:"20px",marginBottom:"10px"}}>
        <Col xs="2">
          <Button style={{"borderRadius":"5px"}} color="success" onClick={() => this.ReleaseToDev()} > Move back to Dev</Button>
        </Col>
        <Col xs="2">
        {
          showSuspendButton ? <Button style={{"borderRadius":"5px"}} color="success" onClick={() => this.suspend()} >Suspend</Button> : null
        }
        {
          showReleaseButton ? <Button style={{"borderRadius":"5px"}} color="success" onClick={() => this.release()} >Release</Button> : null
        }
        </Col>
        <Col xs="5">
        </Col>
        <Col xs="3">
        </Col>
      </Row>

             <Row style={{marginTop:"20px"}}>
          <Col xs="6" >
            <Card>
              <CardHeader>
               <strong> Storyboards Details </strong>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <FormGroup row>
                      <Col xs="12" >
                        <h2 >  <Label>Title</Label> </ h2>
                      </Col>
                      <Col xs="12" >
                       <p> { this.state.scriptDetail.title } </p>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>

                 <Row>
                  <Col>
                    <FormGroup row>
                      <Col xs="12" >
                        <h2 > <Label>Description</Label> </h2>
                      </Col>
                      <Col xs="12">
                        <p>
                         { this.state.scriptDetail.description }
                        </p>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup row>
                      <Col xs="12" >
                        <h2 > <Label>Status</Label> </h2>
                      </Col>
                      <Col xs="12">
                        <p>
                         { this.state.scriptDetail.status }
                        </p>
                      </Col>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

           <Col xs="6" >
            <Card>
              <CardHeader>
               <strong> Storyboards Assets </strong>
              </CardHeader>
              <CardBody>
            <Col xs="12" className="mb-4">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeAssetTab === '11' })}
                  onClick={() => { this.assetToggle('11'); }}
                >
                 Video
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeAssetTab === '22' })}
                  onClick={() => { this.assetToggle('22'); }}
                >
                  Cover Image
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeAssetTab}>
              <TabPane style={{ verticalAlign:"center", textAlign:"center", height:"222px",width:"100%"}} tabId="11">
              {
                 (typeof this.state.scriptDetail.explanationAssetId !== 'undefined') &&  this.state.scriptDetail.explanationAssetId && this.state.scriptDetail.explanationAssetId.length > 0?
                    (this.state.scriptDetail.explanationAssetId.substr(this.state.scriptDetail.explanationAssetId.length-1,1)=="8"?
                      <ReactHLS style={{"marginLeft":"2%", "height":"222px","width":"auto"}} videoProps={{"height":"222","width":"auto"}} url={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.scriptDetail.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}/>:
                      <video style={{"marginLeft":"2%", "width":"auto", "height":"222px"}}  width="auto" height="222" controls src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.scriptDetail.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}></video>
                    ): null
              }
              </TabPane>
              <TabPane style={{verticalAlign:"center", textAlign:"center", height:"222px",width:"100%"}}  tabId="22">
              {
                (typeof this.state.scriptDetail.landScapeImageAssetId !== 'undefined') &&  this.state.scriptDetail.landScapeImageAssetId &&  this.state.scriptDetail.landScapeImageAssetId.length > 0?
                <img style={{"height":"100%"}} src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.scriptDetail.landScapeImageAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken} />
                : null
              }
              </TabPane>
            </TabContent>
            </Col>
              </CardBody>

            <CardFooter  > </CardFooter>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="6">
            <Widget04 icon="icon-frame" style={{backgroundColor:"#63C2E4", color:"#ffffff"}} header={this.state.scriptDetail.assets.length}>SHOTS</Widget04>
          </Col>
          <Col xs="6">
            <Widget04 icon="icon-camrecorder" style={{backgroundColor:"#82D19D", color:"#ffffff"}} header={this.state.scriptDetail.shots.length}>USER GENERATED SHOTS</Widget04>
          </Col>
        </Row>


        <Row>



          {

                  this.state.scriptDetail.shots.map((item) => {
                    return (

                            <Col xs="4">
                              <Card>
                                      <CardHeader>
                                         Shot #{item.shotNumber}. { item.originalFileName }

                                          <Badge style={{float:"right"}} color="success">UGV</Badge>

                                        </CardHeader>
                                        <CardBody >
                                          <p> { item.title } </p>
                                          <p> { item.description } </p>
                                          <p> { item.durationMillis} ms</p>
                                          <p> <i className="fa fa-edit fa-lg mt-4"></i> <a style = {{color:"#00a0e9", cursor:"pointer"}} onClick = {() => {this.detailsShotOpen(item)}}> More Details</a></p>

                                          <div style={{height:"166px"}}>
                                          {
                                             (typeof item.imageAssetId !== 'undefined') && item.imageAssetId &&  item.imageAssetId.length > 0?
                                            <img style={{"height":"100%","width":"100%"}} src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(item.imageAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken} />
                                            :null
                                          }
                                          </div>


                                        </CardBody>
                                  </Card>
                            </Col>


                    );
                  })

              }


         </Row>
        </div>



       )

    } else {
      return;
    }

  }


  render() {

    const { navigate, path } = this.state

    // here is the important part
    if (navigate) {
      console.log(path);
      return <Redirect to={ "/" + path } push={true} />
    }
    return (
      <div className="animated fadeIn">
       <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '1' })}
                  onClick={() => { this.toggle('1'); }}
                >
                <i className="fa fa-file mt-2"></i> Story
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '2' })}
                  onClick={() => { this.toggle('2'); }}
                >
                <i className="fa fa-suitcase mt-2"></i> Assets
                </NavLink>
              </NavItem>
              {/*
              <NavItem>
                <NavLink
                  className={classnames({ active: this.state.activeTab === '3' })}
                  onClick={() => { this.toggle('3'); }}
                >
                <i className="fa fa-pie-chart mt-2"></i> Metrics
                </NavLink>
              </NavItem>
              */}
       </Nav>

        <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
              { this.renderDetailsBody() }

              </TabPane>
              <TabPane tabId="2">
                 <div className="animated fadeIn">
         <Row>
          <Col xs="8">

           <Card>
              <CardHeader>
                View/Watch Asset
              </CardHeader>
              <CardBody>
                <Row>

                  <Col style={{"height":"300px"}}>
                  {
                    this.renderTag()
                  }
                  </Col>
                </Row>

              </CardBody>
            </Card>
          </Col>

           <Col xs="1">


          </Col>

          <Col xs="2">
             <p> Filter By</p>
             <p> <Input type="radio"  name="radio1"  checked={this.state.assetType==="Image"} onChange={()=>{this.setState({assetType:'Image'}, () => {this.getSearchableAssets()});}}/> Image  </p>
             <p> <Input type="radio"  name="radio1"  checked={this.state.assetType==="Video"} onChange={()=>{this.setState({assetType:'Video'}, () => {this.getSearchableAssets()});}}/> Video  </p>
             <p> <Input type="radio"  name="radio1"  checked={this.state.assetType==="Audio"} onChange={()=>{this.setState({assetType:'Audio'}, () => {this.getSearchableAssets()});}}/> Audio </p>

             <p> <Input type="radio"  name="radio2"  checked={this.state.shotType==="DG"} onChange={()=>{this.setState({shotType:'DG'}, () => {this.getSearchableAssets()});}}/> DG </p>
             <p> <Input type="radio"  name="radio2"  checked={this.state.shotType==="UGV"} onChange={()=>{this.setState({shotType:'UGV'}, () => {this.getSearchableAssets()});}}/> UGV  </p>
             <p> <Input type="radio"  name="radio2"  checked={this.state.shotType==="Stock"} onChange={()=>{this.setState({shotType:'Stock'}, () => {this.getSearchableAssets()});}}/> Stock </p>


             <p> <Input type="radio"  name="radio3"  checked={this.state.shotMedia==="Movie"} onChange={()=>{this.setState({shotMedia:'Movie'}, () => {this.getSearchableAssets()});}}/> Movie  </p>
             <p> <Input type="radio"  name="radio3"  checked={this.state.shotMedia==="Shot"} onChange={()=>{this.setState({shotMedia:'Shot'}, () => {this.getSearchableAssets()});}}/> Shot </p>
             <p> <Button style={{"borderRadius":"5px"}} onClick={() => { this.setState({
       assetType:'',
       shotMedia:'',
       shotType:'',
    },() => this.getSearchableAssets())}} color="danger"> Reset </Button> </p>

          </Col>


         </Row>

         <Row style={{"marginTop":"20px"}}>
          <Col>
           <DataTable value={this.state.assets} paginator={true} rows={200} sortField="brand" selectionMode="single" selection={this.state.selectedSale} onSelectionChange={ (e) =>{ this.setState({selectedSale: e.data}); if(e.data.mediaType === "Image") {this.setState({isVideo:false}) } else {this.setState({isVideo:true})  } ;if (e.data.assetType=="Flic" || e.data.assetType=="FlicShot" ||e.data.assetType=="FlicLandscapeStill" || e.data.assetType=="FlicThumbnail") {    let url = e.data.assetId?"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(e.data.assetId) + "?storyboardId=" + e.data.scriptId + "&flicId=" + e.data.flicId + "&authToken=" + this.props.user.authToken:""; this.setState({activeAssetUrl:url},() => console.log(this.state.activeAssetUrl)) } else { let url = e.data.assetId?"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(e.data.assetId) + "?storyboardId=" + e.data.scriptId + "&authToken=" + this.props.user.authToken:""; this.setState({activeAssetUrl:url},() => console.log(this.state.activeAssetUrl)) } }}  sortOrder={1}>
                <Column field="date" header="Date" style={{width:'90px'}} filterPlaceholder="Search" filter={true} sortable={true}/>
                <Column field="projectType" header="Project Type" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
                <Column field="scriptTitle" header="Storyboard" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
                <Column field="shotNumber" header="Shot Number" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
                <Column field="shotTitle" header="Shot Title" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
                <Column field="user" header="User" style={{width:'100px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
                <Column field="mediaType" header="Media" style={{width:'70px'}} filter={true} filterPlaceholder="Search" sortable={true}/>
                <Column field="sourceType" header="Source" style={{width:'70px'}} filterPlaceholder="Search" filter={true} sortable={true}/>
                <Column field="shotMedia" header="AssetType" style={{width:'90px'}} filterPlaceholder="Search" filter={true} sortable={true}/>
            </DataTable>
          </Col>
         </Row>
      </div>
              </TabPane>
              <TabPane tabId="3">


              </TabPane>
        </TabContent>


         <Modal size="lg" isOpen={this.state.detailsShotModalOpen}>
                  <ModalHeader >{ this.state.selectedShot.originalFileName } </ModalHeader>
                  <ModalBody>
                    <Row>
                      <Col xs="5">
                       <Row>
                        <Col>
                          <FormGroup row>
                            <Col xs="12" >
                              <Label htmlFor="text-input"><b>Title</b></Label>
                            </Col>
                            <Col xs="12" >
                              <p> {this.state.selectedShot.title} </p>
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>

                       <Row>
                        <Col>
                          <FormGroup row>
                            <Col xs="12" >
                              <Label htmlFor="text-input"><b>Shot instructions</b></Label>
                            </Col>
                            <Col xs="12" >
                              <p>  { this.state.selectedShot.description } </p>
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>

                       <Row>
                        <Col>
                        shot length
                        </Col>
                      </Row>

                      <Row style={{"font-size":"24px"}}>
                        <Col>
                          { this.state.selectedShot.durationMillis } ms
                        </Col>
                      </Row>

                      </Col>
                      <Col xs="7">
                       <Card>
                          <CardHeader>
                           <strong> Shots Assets </strong>
                          </CardHeader>
                          <CardBody>
                        <Col xs="12" className="mb-4">
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: this.state.activeShotTab === '111' })}
                              onClick={() => { this.shotToggle('111'); }}
                            >
                             Video
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({ active: this.state.activeShotTab === '222' })}
                              onClick={() => { this.shotToggle('222'); }}
                            >
                              Cover Image
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.activeShotTab}>
                          <TabPane style={{verticalAlign:"center", textAlign:"center", height:"222px",width:"100%"}} tabId="111">
                          {
                            (typeof this.state.selectedShot.explanationAssetId !== 'undefined') &&  this.state.selectedShot.explanationAssetId && this.state.selectedShot.explanationAssetId.length > 0?
                               (this.state.selectedShot.explanationAssetId.substr(this.state.selectedShot.explanationAssetId.length-1,1)=="8"?
                                 <ReactHLS style={{"marginLeft":"2%", "height":"190px", "width":"auto"}} videoProps={{"height":"190","width":"auto"}} url={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.selectedShot.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}/>:
                                 <video style={{"marginLeft":"2%", "width":"auto", "height":"222px"}}  width="auto" height="222" controls src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.selectedShot.explanationAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken}></video>
                               ): null
                          }
                          </TabPane>
                          <TabPane style={{verticalAlign:"center", textAlign:"center", height:"222px",width:"100%"}}  tabId="222">
                          {
                            (typeof this.state.selectedShot.imageAssetId !== 'undefined') && this.state.selectedShot.imageAssetId && this.state.selectedShot.imageAssetId.length > 0?
                              <img style={{"height":"100%"}} src={"https://screen.mobflic.com/v1/customers/"+  this.props.user.customerId+ "/assets/" + encodeURIComponent(this.state.selectedShot.imageAssetId) + "?storyboardId=" + this.state.scriptDetail.id + "&authToken=" + this.props.user.authToken} />
                              :null
                          }
                          </TabPane>
                        </TabContent>
                        </Col>
                          </CardBody>

                        <CardFooter  ></CardFooter>
                        </Card>
                      </Col>
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => this.detailsShotClose()} >Cancel</Button>
                  </ModalFooter>
                </Modal>



             <Modal  isOpen={this.state.uploadModalOpen}>
                  <ModalHeader>Upload a storyboard</ModalHeader>
                  <ModalBody>
                    Upload your storyboard files and assets to your portal
                    <Row style={{marginTop:"50px",padding:"20px 30px"}}>
                      <Col>
                      <Input type="file" id="file-input" name="file-input"/>
                      </Col>
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="secondary" onClick={() => this.uploadModalClose()} >Submit</Button>
                    <Button color="secondary" onClick={() => this.uploadModalClose()} >Cancel</Button>
                  </ModalFooter>
                </Modal>



      </div>
    )
  }
}

function mapStateToProps(state) {
    return {
        user: state.activeUser,
    };
}



export default connect(mapStateToProps)(LiveStoryboardDetailsPage);



// WEBPACK FOOTER //
// ./src/views/Components/LiveStoryboardDetails/liveStoryboardDetails.js